export default __webpack_public_path__ + "static/image4-497fcc15fe80924e8367b3697b824a95.png";